module.exports = __webpack_public_path__ + "img/33.3000138a.jpg";